<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        {{ $t('auth.create_account') }}
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        {{ $t('auth.already_have_account') }}
        <router-link to="/login" class="font-medium text-primary hover:text-indigo-500">
          {{ $t('auth.login') }}
        </router-link>
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form class="space-y-6" @submit.prevent="handleRegister">
          <div>
            <label for="name" class="block text-sm font-medium text-gray-700">
              {{ $t('auth.full_name') }}
            </label>
            <div class="mt-1">
              <input id="name" name="name" type="text" autocomplete="name" required v-model="name"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm">
            </div>
          </div>

          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">
              {{ $t('auth.email') }}
            </label>
            <div class="mt-1">
              <input id="email" name="email" type="email" autocomplete="email" required v-model="email"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm">
            </div>
          </div>
          
          <div>
            <label for="phone" class="block text-sm font-medium text-gray-700">
              {{ $t('auth.phone') }}
            </label>
            <div class="mt-1">
              <vue-tel-input v-model="phone" mode="international" :input-options="{ placeholder: $t('auth.phone_placeholder'), required: true }" @validate="onPhoneValidate"></vue-tel-input>
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">
              {{ $t('auth.password') }}
            </label>
            <div class="mt-1">
              <input id="password" name="password" type="password" autocomplete="new-password" required v-model="password"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm">
            </div>
          </div>

          <div>
            <label for="password_confirmation" class="block text-sm font-medium text-gray-700">
              {{ $t('auth.confirm_password') }}
            </label>
            <div class="mt-1">
              <input id="password_confirmation" name="password_confirmation" type="password" autocomplete="new-password" required v-model="password_confirmation"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm">
            </div>
          </div>

          <div>
            <button type="submit" :disabled="loading"
              class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50">
              <span v-if="loading">{{ $t('auth.registering') }}</span>
              <span v-else>{{ $t('auth.register') }}</span>
            </button>
          </div>

          <div v-if="error" class="text-red-600 text-sm text-center mt-2 bg-red-50 p-2 rounded border border-red-200">
            {{ error }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '@/services/authService'

export default {
  name: 'Register',
  data() {
    return {
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      phone: '',
      phoneObject: { valid: false },
      loading: false,
      error: null
    }
  },
  methods: {
    onPhoneValidate(phoneObject) {
       this.phoneObject = phoneObject;
    },
    async handleRegister() {
      this.loading = true
      this.error = null
      
      if (!this.phoneObject.valid) {
          this.error = this.$t('auth.invalid_phone');
          this.loading = false
          return;
      }

      if (this.password !== this.password_confirmation) {
          this.error = this.$t('auth.password_mismatch')
          this.loading = false
          return
      }

      try {
        await authService.register({
          name: this.name,
          email: this.email,
          phone: this.phoneObject.number, // Send formatted number
          password: this.password,
          password_confirmation: this.password_confirmation
        })
        
        await this.$store.dispatch('auth/checkSession')
        this.$router.push('/')
      } catch (err) {
        // Generic error message for security, unless validation error
        if (err.response?.status === 422) {
             this.error = Object.values(err.response.data.errors).flat().join(', ');
        } else {
             this.error = err.response?.data?.message || this.$t('auth.generic_register_error');
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
